/** @module Sourcing/MassLineItemZipDownload */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action/Controller",
	"csi/comm/Aspera",
	"csi/comm/GetRequest",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,csi,Controller,Aspera,GetRequest,PostRequest,locale,xml,Query) {

	return declare(Controller, {

		/** @property {string} productType - taking from Action ControllerClassParamsparameter to filter SRLineItem  by RequestType*/
		productType: "",
		/**
		 * Filter the list of SRLineItem by RequestType given the ID of the source action
		 * @param {Widget} [view]
		 */
		applyActionFilters: function(view) {
			var q = new Query();
			q.Attr("RequestType", xml.OP_EQUALS, "DataPackageContainerType:" + this.productType, "Child:__Parent__");
			view.relRoot.addQuery(q);
			this.inherited(arguments);
		},
		/**
		 * @override
		 * Add submit action
		 */
		addProxyActions: function(defView, defActions) {
			var submitButton = "BUTTON_DOWNLOAD";
			defActions.addAction(this.getProxyAction(submitButton, false, {m_bSubmit: true}));
			this.inherited(arguments);
		},
		/**
		 * @override
		 * Request for selected Nodes file zip.
		 */
		toWriter: async function() {
			var urls = this.m_formData.getSelectedNodes().map(o => o["$URL"]);
			if (Aspera.isEnabled()) {
				for (const url of urls) {
					let request = new PostRequest("Sourcing", "DataPackageZipDownload").addParameter("URL", url);

					await request.post({handleAs: "json"}).then(
						(response) => {
							transferSpec = response.data;
							return Aspera.downloadFileFromSpec(transferSpec);
						}
					).then(
						function() {
							if (transferSpec) {
								let deleteRequest = new PostRequest("SiteAdmin", "DeleteDataPackageZip");
								deleteRequest.addParameter("FileName", transferSpec.transfer_specs[0].transfer_spec.paths[0].destination);
								return deleteRequest.post();
							} else {
								return null;
							}
						}
					).then(
						(msg) => {
							this.postProcess();
						}
					);
				}
			} else {
				urls.forEach( url => {
					var request = new GetRequest("Sourcing", "LineItemZipDownload").addParameter("URL", url);
					csi.browserWindow(request.toRequest(), url);
				});
			}
		}
	});
});